// The admin bell's view of a notification, and its order — pure, so tested.

import type { NotificationLevel } from "@bednbody/logic";

export interface AdminNotification {
  id: string;
  event: string;
  title: string;
  body: string;
  level: NotificationLevel;
  readAt: string | null;
  createdAt: string;
  /** Where opening it goes — a record when the row names one (0278). */
  href: string;
}

/**
 * Bell order: UNREAD urgent first (an unread SOS or payment issue must not sink
 * under newer routine news), then everything else newest first.
 */
export function sortForBell(rows: readonly AdminNotification[]): AdminNotification[] {
  const pinned = (row: AdminNotification) => !row.readAt && row.level === "urgent";
  return [...rows].sort((a, b) => {
    if (pinned(a) !== pinned(b)) return pinned(a) ? -1 : 1;
    return Date.parse(b.createdAt) - Date.parse(a.createdAt);
  });
}
